export default __webpack_public_path__ + "static/media/orbita_front.3f07e44d.jpg";